import React from 'react';

import ButtonBack from './button-back.jsx';

export default class SideNavbar extends React.PureComponent {
  render() {
    const state = this.props.state;
    if (state === 'login') {
      return null;
    }

    const listViews = ['contacts', 'people', 'archive', 'blocked'];
    if (listViews.includes(state)) {
      return (
        <div id="side-caption-panel" className="qq-list-header">
          <div className="qq-list-heading">
            <div id="sidepanel-title" className="qq-list-title">{this.props.title}</div>
          </div>
          <div className="qq-list-actions">
            {this.props.onNewTopic ?
              <button type="button" className="qq-icon-button" title="发起聊天" aria-label="发起聊天"
                onClick={this.props.onNewTopic}>
                <i className="material-icons">add</i>
              </button> : null}
            {this.props.onSettings ?
              <button type="button" className="qq-icon-button" title="设置" aria-label="设置"
                onClick={this.props.onSettings}>
                <i className="material-icons">settings</i>
              </button> : null}
          </div>
        </div>
      );
    }

    return (
      <div id="side-caption-panel" className="qq-sub-header">
        {this.props.onCancel ? <ButtonBack onBack={this.props.onCancel} /> : null}
        <div id="sidepanel-title" className="qq-list-title">{this.props.title}</div>
      </div>
    );
  }
}
